import { _decorator } from 'cc';
import Lobby from '../System/Lobby';
import BaseGameLauncher from '../../common/scripts/BaseGameLauncher';

const { ccclass, executionOrder } = _decorator;

@ccclass('GameLauncher')
@executionOrder(-1)
export default class GameLauncher extends BaseGameLauncher {
    protected launchGame() {
        Lobby.Instance.quickLaunch();
    }
}
